import { useAppSelector } from '@redux/hooks';

const usePdfUrl = () => {
	const pdfUrl = useAppSelector(
		(state) => state.vendor.vendorRaw?.faq?.pricing?.sheet?.url,
	);

	return pdfUrl || null;
};

export { usePdfUrl };
